import React from 'react';
import { Tab, Tabs } from '@material-ui/core';

import cx from 'classnames';
import PaperUI from '../../components/UI/Paper/PaperUI';

import useStyles from './TabCardLayoutAccordion.styles';
import LoadingUI from '../../components/UI/Loading/LoadingUI';


function TabCardLayout({
  separate = false,
  showLoading = false,
  tabItems,
  parentStates,
  footerComponent = null,
}) {
  const styles = useStyles();
  const [value, setValue] = parentStates;

  const classes = cx({ [styles.separator]: separate, [styles.bsNone]: !separate });

  const tabChangeHandler = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <LoadingUI show={showLoading} />
      <PaperUI className={classes}>
        <div className={styles.appBar}>
          <Tabs
            value={value}
            onChange={tabChangeHandler}
            classes={{ indicator: styles.tabSelectColor }}
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabItems.map((item) => {
              if (item) {
                return (
                  <Tab
                    disabled={item.disabled}
                    className={styles.ajustWhiteSpace}
                    key={item.id}
                    id={item.id}
                    label={item.label}
                    aria-controls={item.ariaControl}
                  />
                );
              }
              return null;
            })}
          </Tabs>
        </div>
        {footerComponent}
      </PaperUI>
    </>
  );
}

export default React.memo(TabCardLayout);
